import React, { Component } from "react";
import { Row, Col, List, Card } from "antd";
import ContactImage from "../../assets/homepage-joint-logo.jpg";
export default class ContactUs extends Component {
  state = {
    data: [
      {
        contact_id: 3,
        created_date: "07/01/2021 19:08:06",
        last_updated_date: "29/08/2020 07:08:38",
        is_approved: false,
        is_active: true,
        created_by: "kumarb",
        last_updated_by: "kumarb",
        title: "Customer Management Cell",
        designation: "",
        company_name: "AM/NS India",
        address1: "27km, Surat, Hazira Rd, Hazira",
        address2: "Gujarat - 394270",
        address3: "India",
        email_id: "crp@amns.in",
        phone_no: "",
      },
    ],
  };

  render() {
    return (
      <div>
        <div className="feedbackContainer">
          <Row>
            <Col span={24}>
              <List
                grid={{ gutter: 24, xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
                dataSource={this.state.data}
                loading={false}
                renderItem={(item) => (
                  <List.Item>
                    <Card title={item.title} className="contact-card">
                      <em>
                        <strong>{item.designation}</strong>
                      </em>
                      <br />
                      {item.company_name}
                      <br />
                      {item.address1}
                      <br />
                      {item.address2}
                      <br />
                      {item.address3}
                      <br />
                      Email ID : {item.email_id}
                      <br />
                      Contact No :{item.phone_no}
                    </Card>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col className="contact-col">
              <img alt="" src={ContactImage} className="contact-img" />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
